import NextLink from 'next/link';
import styled, { createGlobalStyle } from 'styled-components';

import {
  mqLargeMax,
  mqSmallMax,
  mqXSmallMax,
  mqXXLargeMax,
  mqXXLargeMin,
  mqLargeMin,
} from 'styled/tools/media-queries';

export const PillBase = styled.div`
  border-radius: 16px;
  padding: 4px 8px;
  width: fit-content;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
`;

export const LearnMoreBase = styled(NextLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: var(--spacing--x2, 16px) var(--spacing--x3, 24px);
  border-radius: 100px;
`;

export const AddToCartBase = styled(NextLink)`
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid;
  padding-bottom: 4px;
  width: fit-content;
  margin-left: 16px;
  font-weight: 500;

  &:hover,
  &:focus {
    color: inherit;
  }

  @media ${mqLargeMin} {
    margin-left: 24px;
  }
`;

// REFACTOR NOTE: EVERYTHING BELOW IS OLD AI CODE

export const ProductsSection = styled.div`
  background-color: var(--fill-bright);
  border-radius: var(--radius-xl);
  margin: 0 auto;
  display: flow-root;
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-16);
  margin: 0 auto 24px auto;
  height: fit-content;
  padding: var(--spacing-16);
  max-width: 1440px;

  .product-pill {
    font-size: 12px;
    font-style: normal;
    font-weight: 350;
    line-height: 100%; /* 12px */
    letter-spacing: -0.24px;
    height: 20px;
  }

  /* Each product card takes up exactly half the width */
  > * {
    width: 100%;
    height: auto; /* Let flexbox handle height naturally */
    min-width: 0;
  }

  .product-card-content-container {
    padding-right: 2rem;
  }

  /* Grid product card height controls */
  .grid-product {
    #product-price-container {
      gap: 4px !important;
    }

    @media (max-width: 400px) {
      .product-card-image-container {
        flex-basis: 30%;
      }
    }

    @media ${mqSmallMax} {
      height: 245px;
    }

    @media ${mqXSmallMax} {
      height: auto;
    }

    @media (min-width: 481px) and (max-width: 770px) {
      height: clamp(245px, 35vw, 320px); /* Grows from 245px to 320px */
    }

    @media (min-width: 771px) and (max-width: 1024px) {
      height: clamp(320px, 40vw, 360px); /* Grows from 320px to 360px */
    }

    @media (min-width: 1025px) {
      height: 375px;

      #product-price-container {
        gap: 8px !important;
      }

      .product-card-image-container {
        flex-basis: 50%;
      }
    }

    /* Mobile: Custom spacing and padding */
    @media (max-width: 770px) {
      .product-card-content-container {
        gap: 8px;
        padding: 0;
      }

      #product-header-container {
        gap: 0;
      }

      #product-info-container {
        gap: 8px;
      }

      #add-to-cart-button,
      #digioh-vs-out-of-stock-cta-button {
        height: 16px;

        font-size: 14px;
        font-style: normal;
        font-weight: 350;
        line-height: normal;
        letter-spacing: -0.035px;
      }

      #learn-more-button {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 1;
        letter-spacing: -0.035px;
      }

      .product-image-wrapper {
        max-height: 130px;
      }

      .product-pill {
        font-size: 10px;
        font-style: normal;
        font-weight: 350 !important;
        line-height: 100%; /* 10px */
        letter-spacing: -0.2px;
        padding: 5px;
        height: 17px;
      }
    }

    /* Tablet: Larger images for 770px to 1024px */
    @media (min-width: 771px) and (max-width: 1024px) {
      .product-image-wrapper {
        max-height: 200px; /* Increased from 130px */
      }
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 1024px) and (min-width: 500px) {
    max-width: 665px;
  }
`;

export const GlobalPageStyles = createGlobalStyle`
  html:has(#page-products) {
    scroll-behavior: smooth;
  }

  main {
    background-color: var(--fill-brand);
    margin-top: -3.5rem; //absolute hack!!!!
  }

  @media (max-width: 1024px) {
    #slide-text-container {
      max-width: 630px;
      margin: 0 auto;
    }
  }

  @media ${mqXXLargeMin} {
    #slide-text-container {
      max-width: 1380px;
      margin: 0 auto;
    }
  }

  @media ${mqXXLargeMax} {
    #slide-content-0 {
      padding-inline: var(--spacing-32);
    }
  }
  @media ${mqLargeMax} {
    #slide-content-0 {
      padding-inline: var(--spacing-16);
    }
  }
`;
